<template lang="html">
  <div>
    <v-form v-model="formularioValido" ref="form">
      <v-container>
        <v-layout row wrap justify-space-between v-if="this.permissaoEditar(this.projeto.situacao.item)">
          <v-flex xs12>
            <v-text-field label='Título' v-model="projeto.titulo" required
              :rules="this.maiorQue150 ? regrasBasicas : tituloRules" max-height="400" counter="150">
            </v-text-field>
          </v-flex>
        </v-layout>

        <v-layout row wrap justify-space-between v-if="this.permissaoEditar(this.projeto.situacao.item)">
          <v-flex xs11 sm5>
            <v-select label='Tipo de público-alvo' :items="listaTipoPublico" v-model="projeto.tipoPublico"
              item-text="descricao" item-value="item" prepend-icon="dashboard" max-height="400" return-object required
              autocomplete :rules="regrasBasicas">
            </v-select>
          </v-flex>

          <v-flex xs11 sm5>
            <v-text-field-integer v-model="projeto.publicoAlvo" label='Público-alvo estimado' v-bind:properties="{
              rules: numerico
            }" />
          </v-flex>
        </v-layout>

        <v-layout v-if="this.permissaoEditar(this.projeto.situacao.item)">
          <v-flex xs11 sm5 v-if="projeto.classificacaoSecundaria.id === 39729">
            <v-text-field-integer v-model="projeto.cargaHoraria" label="Carga horária do curso" v-bind:properties="{
              rules: numerico
            }" />
          </v-flex>
        </v-layout>

        <v-layout v-if="this.permissaoEditar(this.projeto.situacao.item)">
          <v-flex xs11 sm5 v-if="projeto.classificacaoSecundaria.id === 44194">
            <v-text-field-integer v-model="projeto.cargaHoraria" label="Carga horária do curso" v-bind:properties="{
              rules: numerico
            }" />
          </v-flex>
        </v-layout>

        <v-layout v-if="this.permissaoEditar(this.projeto.situacao.item)">
          <v-flex xs11 sm5 v-if="projeto.classificacaoSecundaria.id === 44195">
            <v-text-field-integer v-model="projeto.cargaHoraria" label="Carga horária da oficina" v-bind:properties="{
              rules: numerico
            }" />
          </v-flex>
        </v-layout>

        <v-layout v-if="this.permissaoEditar(this.projeto.situacao.item)">
          <v-flex xs11 sm5 v-if="projeto.classificacaoSecundaria.id === 39730">
            <v-text-field-integer v-model="projeto.cargaHoraria" label="Carga horária do evento" v-bind:properties="{
              rules: numerico
            }" />
          </v-flex>
        </v-layout>

        <p v-if="projeto.classificacaoSecundaria.id !== 39729 && projeto.classificacaoSecundaria.id !== 44194 && projeto.classificacaoSecundaria.id !== 44195"
          class="mt-3"></p>

        <v-layout row wrap>
          <v-flex xs11 sm5>
            <v-checkbox
              v-if="(projeto.classificacaoSecundaria && projeto.classificacaoSecundaria.id === 39733)"
              v-model="dataConclusaoSemLimite" :value="true" @change="onChangeDataSemLimite">
              <template v-slot:label>
                <div>Essa é uma ação contínua, sem data limite</div>
              </template>
            </v-checkbox>
          </v-flex>
        </v-layout>

        <v-layout row wrap v-if="this.permissaoEditar(this.projeto.situacao.item)">
          <v-flex xs11 sm5>
            <v-text-field label="Data de início" v-model="projeto.dataInicio" required type="date" :rules="regrasBasicas"
              :disabled="projeto.relatorioFinalHabilitado === true">
            </v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs11 sm5>
            <v-text-field label="Data de conclusão" v-model="projeto.dataConclusao" required type="date"
              :rules="dataConclusaoRules" :disabled="projeto.relatorioFinalHabilitado === true">
            </v-text-field>
          </v-flex>
        </v-layout>

        <v-layout row wrap justify-space-between v-if="this.permissaoEditar(this.projeto.situacao.item)">
          <v-flex xs11 sm2>
            <v-text-field label='Palavra-chave 1' v-model="projeto.palavraChave01" required :rules="regrasBasicas"
              max-height="400">
            </v-text-field>
          </v-flex>
          <v-flex xs11 sm2>
            <v-text-field label='Palavra-chave 2' v-model="projeto.palavraChave02" required :rules="regrasBasicas"
              max-height="400">
            </v-text-field>
          </v-flex>
          <v-flex xs11 sm2>
            <v-text-field label='Palavra-chave 3' v-model="projeto.palavraChave03" required :rules="regrasBasicas"
              max-height="400">
            </v-text-field>
          </v-flex>
          <v-flex xs11 sm2>
            <v-text-field label='Palavra-chave 4' v-model="projeto.palavraChave04" max-height="400">
            </v-text-field>
          </v-flex>
        </v-layout>

        <v-layout row wrap justify-space-between v-if="this.permissaoEditar(this.projeto.situacao.item)">
          <v-flex xs12>
            <v-textarea label="Resumo" v-model="projeto.resumo" required :rules="resumoRules" :rows="5" counter="1000">
            </v-textarea>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
    <v-divider></v-divider>
    <v-card-actions>
      <v-btn color="primary" text @click="cancelar">Cancelar</v-btn>
      <v-spacer></v-spacer>
      <v-btn color="primary" text @click="editarProjeto(false)" :disabled="!formularioValido">Salvar</v-btn>
      <v-btn color="primary" text @click="editarProjeto(true)" :disabled="!formularioValido">Salvar e Avançar</v-btn>
    </v-card-actions>
  </div>
</template>

<script>
import ToolTip from '@/components/app-layouts/app-tooltip/tooltip'
import DataMenu from '@/components/c-date-menu'
import TextArea from '@/components/c-textarea'
import BasicToolbar from '@/components/toolbars/basic-toolbar'
import dates from '@/utils/dates'
import projetos from '@/utils/projetos'
import { mapActions, mapGetters } from 'vuex'

export default {
  props: ['idProjeto'],
  data: () => ({
    formularioValido: false,
    dates: dates,
    maiorQue150: false,
    dataConclusaoSemLimite: false,
    projeto: {
      titulo: '',
      projetoSup: undefined,
      resumo: '',
      dataInicial: '',
      dataFinal: '',
      situacao: {},
      tipoPublico: {},
      tipoEvento: {},
      classificacoesPrimariaSecundaria: [{}, {}]
    },
    pesquisa: {
      titulo: undefined
    },
    listaTipoPublico: [],
    listaTipoEvento: [],
    listaSituacao: [],
    regrasBasicas: [
      (input) => !!input || 'Este campo é obrigatório'
    ],
    tituloRules: [
      (input) => !!input || 'Este campo é obrigatório',
      (input) => !!input && input.length <= 150 || 'Este campo não pode possuir mais que 150 caracteres'
    ],
    publicoAlvoEstimadoRules: [
      (input) => !!input || 'Este campo é obrigatório',
      (input) => !isNaN(parseFloat(input)) && input > 0 && input <= 10000000 || 'Público-alvo estimado inválido'
    ],
    dataConclusaoRules: [
      (input) => !!input || 'Este campo é obrigatório'
    ],
    resumoRules: [
      (input) => !!input || 'Este campo é obrigatório',
      (input) => !!input && input.length <= 1000 || 'Este campo não pode possuir mais que 1000 caracteres'
    ],
    numerico: [
      (input) => !!input || 'Este campo é obrigatório',
      (input) => !isNaN(input) || 'Este campo deve ser numérico',
      (input) => (input.length === 0 || Number(input) !== 0) || 'Este campo não pode ser nulo',
      (input) => (input.length === 0 || Number(input) >= 0) || 'Este campo não pode ter valor negativo'
    ]
  }),
  computed: {
    ...mapGetters('auth', ['administrador', 'usuarioPROEX'])
  },
  methods: {
    ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),
    onChangeDataSemLimite: function () {
      this.projeto.dataConclusao = undefined
      if (this.dataConclusaoSemLimite) {
        this.dataConclusaoRules = [true]
      } else {
        this.dataConclusaoRules = [
          (input) => !!input || 'Este campo é obrigatório'
        ]
      }
    },
    permissaoEditar: function (situacaoAcaoExtensao) {
      // Coordenador ou assessor
      if ((this.usuarioCoordenador() || this.usuarioAssessor()) && situacaoAcaoExtensao === 15) {
        return true
      } else if (this.usuarioAdministrador() && [3, 4, 15, 16, 18, 19, 20, 22].includes(situacaoAcaoExtensao)) { // Administrador
        return true
      } else {
        return false
      }
    },
    // Verifica se o usuário logado é o coordenador da ação de extensão.
    usuarioCoordenador: function () {
      if ((this.projeto.funcao != null && this.projeto.funcao.item === 1)) {
        return true
      } else {
        return false
      }
    },
    // Verifica se o usuário logado é assessor da ação de extensão.
    usuarioAssessor: function () {
      if (this.projeto.assessor === true) {
        return true
      } else {
        return false
      }
    },
    // Verifica se o usuário logado é administrador.
    usuarioAdministrador: function () {
      if (this.administrador === true) {
        return true
      } else {
        return false
      }
    },
    cancelar: function () {
      this.$router.push({ name: 'ProjetoFormulario', params: { idProjeto: this.idProjeto } })
    },
    editarProjeto: function (avancar) {
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Editando Projeto.' })
      this.projeto.idProjeto = undefined
      this.projeto.dataRegistro = undefined
      this.projeto.situacao = undefined
      projetos.putProjeto(this.idProjeto, this.projeto)
        .then(response => {
          this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem })
          if (avancar === false) {
            this.$router.push({ name: 'ProjetoFormulario', params: { idProjeto: this.idProjeto } })
          } else {
            this.$router.push({ name: 'EditarClassificacao', params: { idProjeto: this.idProjeto } })
          }
        })
        .catch(error => {
          this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem })
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Editando projeto.' })
        })
    },
    opcoesTabelaEstruturada: function (codTabela, aqui, atributo) {
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando opções.' })
      projetos.getOpcoesTabelaEstruturada(codTabela)
        .then(response => {
          aqui[atributo] = response.data.slice()
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando opções.' })
        })
    }
  },
  mounted: function () {
    this.opcoesTabelaEstruturada(6011, this, 'listaSituacao')
    this.opcoesTabelaEstruturada(6002, this, 'listaTipoPublico')
    this.opcoesTabelaEstruturada(6028, this, 'listaTipoEvento')

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' })
    projetos.getProjeto(this.idProjeto)
      .then(response => {
        this.projeto = response.data
        if (this.projeto.titulo.length > 150) {
          this.maiorQue150 = true
        }
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' })
      })
  },
  components: {
    'basic-toolbar': BasicToolbar,
    'tooltip': ToolTip,
    'c-date-menu': DataMenu,
    'c-textarea': TextArea
  }
}
</script>

<style lang="css">
.menu {
  display: block !important;
}

.no-resize div textarea {
  resize: none;
}

.input-group__icon-cb {
  cursor: pointer !important;
}
</style>



// WEBPACK FOOTER //
// editar-informacoes.vue?093c94de